import { Component } from 'react';
import Space from './Space';
import { generateUUID } from '../GanjiTools';
import { Tooltip } from 'devextreme-react';
import FontAwesomeIcon from './utils/FontAwesomeIcon';

class MinimalButton extends Component {
    constructor(props) {
        super(props);
        this.id = this.props.sid?.length > 0 ? `${this.props.sid}_container` : generateUUID();
        this.state = {
            bg: this.props.normalBackground ?? this.props.background ?? 'transparent',
            fg: this.props.normalColor ?? this.props.color ?? this.props.style?.color ?? 'inherit'
        };
    }

    onContainerLoad = e => {
        console.log(e);
    }

    componentDidMount() {
        this.setState({ containerElem: document.getElementById(this.id) });
    }

    onMouseEnter = () => {
        this.setState({
            bg: this.props.highlightedBackground ?? 'white',
            fg: this.props.highlightedColor ?? 'inherit'
        });
    }

    onMouseLeave = () => {
        this.setState({
            bg: this.props.normalBackground ?? 'transparent',
            fg: this.props.normalColor ?? this.props.color ?? this.props.style?.color ?? 'inherit'
        });
    }

    render() {
        let iconBefore = this.props.iconBefore ?? this.props.icon;

        //let id = this.props.sid?.length > 0 ? this.props.sid + '_container' : generateUUID();
        return (
            <>
                <div onClick={this.props.onClick} id={this.id} onEnded={this.onContainerLoad}
                    onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        cursor: 'pointer',
                        padding: '0',
                        width: this.props.width ?? 'auto',
                        height: this.props.height ?? 'auto',
                        ...this.props.style,
                        background: this.state.bg,
                        color: this.state.fg,
                    }}
                    className={this.props.className}
                //id={this.props.id + '_container'}
                >
                    {iconBefore && (
                        this.props.iconSet === 'fa' || iconBefore.startsWith('fa-') || iconBefore.startsWith('fa_')
                            ?
                            <FontAwesomeIcon icon={iconBefore} type={this.props.iconType} style={this.props.iconStyle}
                                fontSize={this.props.iconSize} {...this.props.iconEffects}
                            />
                            :
                            <span className={'dx-icon-' + iconBefore} style={this.props.iconStyle}></span>
                    )}
                    {iconBefore && <Space width={this.props.spacing ?? this.props.fontSize ?? '5px'} />}
                    <span style={{ color: this.state.fg, ...this.props.textStyle }}>
                        {this.props.text}
                    </span>
                    {this.props.children}
                    {this.props.iconAfter && <Space width={this.props.spacing ?? this.props.fontSize ?? '5px'} />}
                    {this.props.iconAfter && (
                        this.props.iconSet === 'fa' || this.props.iconAfter.startsWith('fa-')
                            ?
                            <FontAwesomeIcon icon={this.props.iconAfter} type={this.props.iconType} style={this.props.iconStyle}
                                fontSize={this.props.iconSize} {...this.props.iconEffects}
                            />
                            :
                            <span className={'dx-icon-' + this.props.iconAfter} style={this.props.iconStyle}></span>
                    )}
                </div>
                {this.props.hint && this.state.containerElem &&
                    <Tooltip target={this.state.containerElem} hideEvent='mouseleave'
                        showEvent={{ name: 'mouseenter', delay: 1000 }}
                    >
                        {this.props.hint}
                    </Tooltip>
                }
            </>
        );
    }
}

export default MinimalButton;